import { render, staticRenderFns } from "./ActividadesNueva.vue?vue&type=template&id=64ce0fd7&scoped=true"
import script from "./ActividadesNueva.vue?vue&type=script&lang=js"
export * from "./ActividadesNueva.vue?vue&type=script&lang=js"
import style0 from "./ActividadesNueva.vue?vue&type=style&index=0&id=64ce0fd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce0fd7",
  null
  
)

export default component.exports